import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import type { CustomerLoyaltyProgramStatsItem } from "../components/data/types"
import { request } from "../utils/http"

export const getCustomerLoyaltyProgramStatsApi = (
    headers: Record<string, any>,
    id: string
): Rx.Observable<CustomerLoyaltyProgramStatsItem> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: `/data/customer-loyalty-program/${id}/stats`,
            headers: headers,
        })
    ).pipe(retry(3))
